<template>
  <div class="container pt-0 m:pt-20 l:pt-0">
    <b-headline type="h2" typography="h35" class="l:hidden text-center mb-8 l:mb-9">
      {{ $t("headline") }}
    </b-headline>
    <b-headline type="h2" typography="h2" class="hidden l:block text-center mb-8 l:mb-9">
      {{ $t("headline") }}
    </b-headline>
    <div class="grid grid-cols-12 w-full">
      <value-column illustration="sharing" :content="firstColumn" />
      <value-column illustration="writing" :content="secondColumn" />
      <value-column illustration="juggle" :content="thirdColumn" />
    </div>
  </div>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import ValueColumn from "./value-column"

export default {
  name: "FormatBannerSection",
  components: {
    ValueColumn,
    BHeadline
  },
  props: {
    inviterName: {
      type: String,
      default: ""
    }
  },
  computed: {
    firstColumn() {
      return {
        title: this.$t("firstColumn.title", { inviterName: this.inviterName }),
        subtitle: this.$t("firstColumn.subtitle", { inviterName: this.inviterName })
      }
    },
    secondColumn() {
      return {
        title: this.$t("secondColumn.title", { inviterName: this.inviterName }),
        subtitle: this.$t("secondColumn.subtitle", { inviterName: this.inviterName })
      }
    },
    thirdColumn() {
      return {
        title: this.$t("thirdColumn.title", { inviterName: this.inviterName }),
        subtitle: this.$t("thirdColumn.subtitle", { inviterName: this.inviterName })
      }
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Enjoy aha-moments together",
        firstColumn: {
          title: "Recommend favorites to each other",
          subtitle:
            "Recommend Blinks and Shortcasts you liked, enjoy collections together, and share collections you create yourselves!"
        },
        secondColumn: {
          title: "Add context and notes to your recommendations",
          subtitle:
            "Leave {inviterName} a note with titles you share, or respond with a comment, so they can be enjoyed with purpose."
        },
        thirdColumn: {
          title: "You decide what and when you want to share",
          subtitle: "You control your own account and decide what {inviterName} sees."
        }
      },
      de: {
        headline: "Erlebt Aha-Momente gemeinsam",
        firstColumn: {
          title: "Teilt eure Lieblingstitel miteinander",
          subtitle:
            "Empfehlt euch spannende Blinkist und Shortcasts, hört kuratierte Kollektionen gemeinsam an oder teilt eure eigenen Kollektionen."
        },
        secondColumn: {
          title: "Füge deinen Empfehlungen Notizen hinzu",
          subtitle:
            "Was fandest du besonders bemerkenswert? Teile eine Notiz mit {inviterName} oder antworte  mit einem Kommentar, um Empfehlungen mehr Kontext zu geben."
        },
        thirdColumn: {
          title: "Du entscheidest, was du teilst und wann du es teilst",
          subtitle: "Du hast die volle Kontrolle über deinen Account – {inviterName} sieht nur, was du geteilt hast. "
        }
      }
    }
  }
}
</script>
